import { Box, Card, Divider, IconButton, Icons, Stack, Typography } from '@healthinal/ui';
import { useState } from 'react';
import { ClinicalReportDto } from '../../../../../api/generated/model';
import { CardRow } from '../../../../../components/CardRow.tsx';
import { SubCard } from '../../../../../components/SubCard.tsx';
import { getClinicalMaterialSummaryStrings, getOrganName, getTbType } from '../../../../../utils/clinicalReport.ts';
import { formatDateWithGermanMonth } from '../../../../../utils/date.ts';
import { FileLink } from '../../../../components/FileLink.tsx';
import { ContactDisplay } from '../../../../components/patient-address/PatientAddressDisplay.tsx';
import { EditClinicalReportDialog } from './EditClinicalReportDialog.tsx';

export function ClinicalReportCard({ report }: { report: ClinicalReportDto }) {
  const [isEditClinicalReportDialogOpen, setIsEditClinicalReportDialogOpen] = useState(false);

  return (
    <>
      <Card>
        <Stack direction={'row'} alignItems={'start'} gap={3}>
          <Stack flex={2} gap={5}>
            <Stack direction={'row'} gap={2}>
              <SubCard>
                <Icons.MedicalInformation />
              </SubCard>
              <Stack justifyContent={'space-between'}>
                <Typography level={'h4'}>MKB</Typography>
                <Typography level={'body-sm'}>{formatDateWithGermanMonth(report.updated)}</Typography>
              </Stack>
            </Stack>
            <Stack gap={1}>
              <CardRow title={'TB'} content={getTbType(report.organs)} />
              <Divider />
              <CardRow
                title={'Befallene Organe'}
                content={report.organs.map((organ) => `${getOrganName(organ, report.otherOrgan)}`).join(', ')}
              />
              <Divider />
              <CardRow title={'Material'}>
                <Box flex={3}>
                  {getClinicalMaterialSummaryStrings(report.materials).map((summary) => (
                    <Typography key={summary} level={'title-sm'}>
                      {summary}
                    </Typography>
                  ))}
                </Box>
              </CardRow>
              <Divider />
              <CardRow title={'Meldender Arzt'}>
                {report.doctorAddress?.contact && (
                  <Box flex={3}>
                    <ContactDisplay contact={report.doctorAddress.contact} showNameAsTitle />
                  </Box>
                )}
              </CardRow>
              <Divider />
              <CardRow title={'MKB'}>
                {report.fileDetails && <FileLink flex={3} fileDetails={report.fileDetails} />}
              </CardRow>
            </Stack>
          </Stack>
          <Stack flex={1}>
            <Typography level={'title-lg'}>Bemerkungen</Typography>
            <Typography level={'body-sm'} sx={{ whiteSpace: 'pre-line' }}>
              {report.notes}
            </Typography>
          </Stack>
          <IconButton
            color={'primary'}
            onClick={() => setIsEditClinicalReportDialogOpen(true)}
            title={'MLB bearbeiten'}>
            <Icons.Edit />
          </IconButton>
        </Stack>
      </Card>
      <EditClinicalReportDialog
        open={isEditClinicalReportDialogOpen}
        onClose={() => setIsEditClinicalReportDialogOpen(false)}
        currentClinicalReport={report}
      />
    </>
  );
}
